import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, useFormState } from 'react-final-form';
import { SelectField } from '../../../../../01_atoms/FormElements';
import { required } from '../../../../../../utils/formFieldValidators';

import styles from './index.module.scss';

const Campaigns = ({ campaigns, campaignsRG, campaign = '' }) => {
  const { values } = useFormState();
  const form = useForm();
  const [formCampaigns, setFormCampaigns] = useState(campaigns);

  useEffect(() => {
    if (values.donation_type === 'monthly' && campaignsRG.length) {
      setFormCampaigns(campaignsRG);
    } else {
      setFormCampaigns(campaigns);
    }
  }, [values.donation_type]);

  useEffect(() => {
    if (campaign) {
      return;
    }
    if (formCampaigns.length === 1) {
      form.mutators.setValue('source_code', formCampaigns[0].value);
    } else {
      form.mutators.setValue('source_code', '');
    }
  }, [formCampaigns]);

  // Don't show the field if the value is already populated or there is only one option.
  if (!campaign && formCampaigns && formCampaigns.length > 1) {
    return (
      <div className={styles['campaigns']}>
        <SelectField
          name="source_code"
          label="What motivated your contribution today?"
          info="Your answer will help us to more effectively plan our fundraising activities"
          placeholder="Select a reason"
          menuPlacement="top"
          validate={required('Please select a reason in order to proceed')}
          isRequired
          options={formCampaigns}
          menuShouldScrollIntoView
          isSearchable={false}
          // We set 1000px to be sure that scrolling
          // will be appeared only if we will have more than ~7 source codes.
          styles={{ menuList: (base) => ({ ...base, maxHeight: '350px' }) }}
        />
      </div>
    );
  }
  return null;
};

Campaigns.propTypes = {
  campaigns: PropTypes.array.isRequired,
  campaignsRG: PropTypes.array.isRequired,
  campaign: PropTypes.string,
};

export default Campaigns;
